// src\dev\common\ErrorPage.js
import './ErrorPage.css';

function ErrorPage(props) {
  const redirectPage = (event, cellValues) => {
    if(window.sessionStorage.getItem('currentUserDetails') === '') {
      window.location.pathname = '/' // redirect to Login page
    } else {
      window.location.pathname = '/home' // redirect to Home page
    }
  }

  return (
    <>
    <div className='errorPage'>
      <br />
      <h1>Something went wrong.</h1>
      <br /><hr /><br />
      <h5>{props.errorMessage}</h5>
      <div className='errorPageButton'>
        <button className='btn btn-primary' onClick={() => redirectPage()}>Continue</button>
      </div>
    </div>
    </>
  )
}

export default ErrorPage;
